import { IBaseDocumentItemKizDTO } from "../../libs/coreapi-dto/documents/base";
import { DocumentType } from '../../@types/enumsGlobal'

export const sumKizsCount = (
    param: any,
    documentType?: DocumentType,
    isUnpackRecursive?: boolean,
    trustedSupplier?: boolean
): number => {

    const isDisaggregation = documentType === DocumentType.disaggregation;
    const isInvoiceOrImport =
        documentType === DocumentType.invoice ||
        documentType === DocumentType.importRemains;

    if (isDisaggregation) {
        const confirmationScannedNo = (param.kizConfirmationScanned?.filter(x => x.infoScanned && x.infoScanned.length > 0).length ?? 0);
        return trustedSupplier ?
            (isUnpackRecursive ? param.kizs?.length ?? 0 : param.kizBoxes?.length ?? 0) :
            confirmationScannedNo;
    }

    if (isInvoiceOrImport) {
        const kizsCount = param.kizs?.length ?? 0;
        const boxesQuantity = param.kizBoxes?.reduce((sum: number, box: any) => sum + (box.quantity ?? 0), 0) ?? 0;
        const kizOsuDtosCount = param.kizOsuDtos?.length ?? 0;
        return kizsCount + boxesQuantity + kizOsuDtosCount;
    }

    // Базовый вариант подсчёта
    return (param.kizs?.length ?? 0) + (param.kizBoxes?.length ?? 0) +  (param.kizOsuDtos?.length ?? 0);
};

export const kizCounter = (items, showMessage: () => void, documentType?: DocumentType, sysOptionsKizValidationType?: string): boolean => {
    
    let kiz: boolean = true;
    for (const x of items) {
        const sumKizsKizBoxesQuantitySum: number =  (x.kizs?.length ?? 0) + 
            (x.kizBoxes ? x.kizBoxes.reduce((currentSum, kizBox) => currentSum + kizBox.quantity, 0) : 0) +
            (x.kizBoxesGisMt ? x.kizBoxesGisMt.reduce((currentSum, kizBoxesGisMt) => currentSum + kizBoxesGisMt.quantity, 0) : 0) +
            (x.kizOsuDtos?.length ?? 0);

        const sumKizsKizBoxes: number = (x?.kizs?.length ?? 0) + (x?.kizBoxes?.length ?? 0) + (x?.kizOsuDtos?.length ?? 0);        
        const quantity: number = x.quantity ?? 0;
        const actualQuantity: number = x.actualQuantity ?? 0;
        const numerator: number = x.numerator ?? 0;
        const denominator: number = x.denominator ?? 0;
        const isKizOsu: boolean = x.isOsu ?? false;
        
        if (x.isKiz || x.isKizBox) {
            // Приходная накладная
            if (documentType === DocumentType.invoice) {
                if (numerator < denominator) {
                    if ((sumKizsKizBoxesQuantitySum !== 1) && !isKizOsu) {
                        kiz = false;
                        break;
                    }
                } else {
                    if (sysOptionsKizValidationType === 'ActualQuantity') {
                        if ((sumKizsKizBoxesQuantitySum < actualQuantity) && !isKizOsu) {
                            kiz = false;
                            break;
                        }
                    } else {
                        if ((sumKizsKizBoxesQuantitySum < quantity) && !isKizOsu) {
                            kiz = false;
                            break;
                        }
                    }
                }
            }

            // Ввод остатков
            if (documentType === DocumentType.importRemains) {
                if (numerator < denominator) {
                    if ((sumKizsKizBoxesQuantitySum !== 1) && !isKizOsu) {
                        kiz = false;
                        break;
                    }
                } else {
                    if ((sumKizsKizBoxesQuantitySum < quantity) && !isKizOsu) {
                        kiz = false;
                        break;
                    }
                }
            }

            // Акт разукомплектации
            if (documentType === DocumentType.disassembling) {
                if ((sumKizsKizBoxes !== x.quantityFrom)) {
                    kiz = false;
                    break;
                }
            }

            // Акт разагрегации
            if (documentType === DocumentType.disaggregation) {
                if (x.kizBoxes?.length === 0 && x.kizs?.length !== quantity) {
                    kiz = false;
                    break;
                }

                // Разагрегация до коробов
                if (x.kizBoxes?.length !== quantity && x.kizs?.length === 0) {
                    kiz = false;
                    break;
                }
            }

            // Акт списания, Перемещение
            if ((documentType === DocumentType.actDeduction) || (documentType === DocumentType.movement)) {
                if (numerator < denominator) {
                    if (sumKizsKizBoxesQuantitySum !== 1) {
                        kiz = false;
                        break;
                    }
                } else {
                    if ((sumKizsKizBoxes !== quantity)) {
                        kiz = false;
                        break;
                    }
                }
            }

            // Инвентаризационная ведомость
            if (documentType === DocumentType.inventoryVed) {
                if ((x.countKizScan !== quantity)) {
                    kiz = false;
                    break;
                }
            }

            // Расходная накладная, Акт возврата поставщику, Акт переоценки
            if (documentType === DocumentType.invoiceOut || documentType === DocumentType.actReturnToContractor || documentType === DocumentType.revaluation) {
                if ((sumKizsKizBoxes !== quantity)) {
                    kiz = false;
                    break;
                }
            }
        }
    }

    if (kiz !== true) {
        showMessage()
    }
    
    return kiz
}
